import { render, staticRenderFns } from "./DomainWhois.vue?vue&type=template&id=e7d39fd4&"
import script from "./DomainWhois.vue?vue&type=script&lang=js&"
export * from "./DomainWhois.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports